import './App.scss';
import BackgroundVideo from './components/BackgroundVideo/BackgroundVideo';

function App() {
	return (
		<div className="App">
			<BackgroundVideo />
		</div>
	);
}

export default App;
